import { render, staticRenderFns } from "./CustomRadioItem.vue?vue&type=template&id=7db993e8&"
import script from "./CustomRadioItem.vue?vue&type=script&lang=js&"
export * from "./CustomRadioItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports